import React from 'react';

function Education() {
    return (
        <div className="rn-education-area rn-section-gap section-separator" id="education">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span className="subtitle">Educational Background</span>
                            <h2 className="title">Education</h2>
                        </div>
                    </div>
                </div>
                <div className="row mt--45">
                    <div className="col-lg-12">
                        <div className="experience-list">
                            <div className="resume-single-list">
                                <div className="inner">
                                    <div className="heading">
                                        <div className="title">
                                            <h4 className='text-primary'>Master of Computer Applications (Web Development)</h4>
                                            <span>Punjabi University</span>
                                        </div>
                                        <div className="date-of-time">
                                            <span>Jul 2019 – May 2021</span>
                                        </div>
                                    </div>
                                    <p className="description">Specialized in advanced web technologies and system architecture during post-graduation.</p>
                                </div>
                            </div>
                            <div className="resume-single-list mt-3">
                                <div className="inner">
                                    <div className="heading">
                                        <div className="title">
                                            <h4 className='text-primary'>Bachelor of Computer Applications</h4>
                                            <span>Punjabi University</span>
                                        </div>
                                        <div className="date-of-time">
                                            <span>Aug 2016 – May 2019</span>
                                        </div>
                                    </div>
                                    <p className="description">Foundational studies in computer science, programming, and software engineering principles.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Education;
